import React, { useContext, useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Badge from '@mui/material/Badge';
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { AppContext } from "../../../Context/AppContext";
import {format,parseISO} from 'date-fns';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import DeleteIcon from '@mui/icons-material/Delete';
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import AddIcon from "@mui/icons-material/Add";
import InputInventoryDialog from "./InputInventoryDialog";
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

const drawerWidth = 300;

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const materialTheme = createTheme(({
    // set default for now
  }));
const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    appBar: {
        position: 'fixed',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    appBarBottom: {
        top: 'auto',
        bottom: 0,
        [theme.breakpoints.up('sm')]: {
        },
    },
    grow: {
        flexGrow: 1,
    },
    productListPaper: {

        marginBottom: 50,
    },
}));






function InventoryReview(props) {
    const classes = useStyles();
    const { companyId } = useContext(AppContext);
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState();
    const [openInventoryAddLotNumberAndExpiration,setOpenInventoryAddLotNumberAndExpiration] = useState(false);
    const [productToDeleteInventory,setProductToDeleteInventory] = useState()
    const [inputtedInventoryToDelete,setInputtedInventoryToDelete] = useState()
    const [showDeleteConfirmationDialog,setShowDeleteConfirmationDialog] = useState(false)


    const inventoryInputDeleteClick = (product,inventory)=>(event)=>{
        setShowDeleteConfirmationDialog(true)
        setProductToDeleteInventory(product)
        setInputtedInventoryToDelete(inventory)
     
    
      }

      const onProductInputtedInventory = (product)=>{
    
        const productsCopy = [...products]
        const productIndex = productsCopy.findIndex((productParam) => productParam.code == product.code);
        if (productIndex >= 0) {
          productsCopy.splice(productIndex, 1, product); //replace object
        } 
        setProducts(productsCopy)
    
      }

      const deleteInventoryBtnClick = ()=>{
        const temporaryInventoryString = localStorage.getItem(companyId + "_temporary_inventory_count");
        if (temporaryInventoryString == null) {
        
          return;
        }
    
        const temporaryInventoryJSON = JSON.parse(temporaryInventoryString);
        const selectedProductInTempDataIndex = temporaryInventoryJSON.findIndex((productParam) => productParam.code == productToDeleteInventory.code);
        const selectedProductInTempData = temporaryInventoryJSON[selectedProductInTempDataIndex]
        const inputtedInventories = selectedProductInTempData.InputtedInventories
        const selectedInventoryIndex = inputtedInventories.findIndex((inventoryParams)=>{
          if(inventoryParams.uom == inputtedInventoryToDelete.uom && inventoryParams.expiration_date == inputtedInventoryToDelete.expiration_date && inventoryParams.lot_number == inputtedInventoryToDelete.lot_number && inventoryParams.quantity == inputtedInventoryToDelete.quantity ){
            return true
          }
          return false
        })
        // delete inputted inventory
        inputtedInventories.splice(selectedInventoryIndex,1) //remove object
        if(inputtedInventories.length <= 0){
          temporaryInventoryJSON.splice(selectedProductInTempDataIndex,1) //remove object
        }
        localStorage.setItem(companyId+ "_temporary_inventory_count",JSON.stringify(temporaryInventoryJSON))

        setProducts(temporaryInventoryJSON)
        setShowDeleteConfirmationDialog(false)
    
    
    
      }
      function totalProductCountWithInventoryInputted(){

        const temporaryInventoryString = localStorage.getItem(companyId + "_temporary_inventory_count");
        if (temporaryInventoryString == null) {
        
          return 0;
        }
    
        const temporaryInventoryJSON = JSON.parse(temporaryInventoryString);
    
        return temporaryInventoryJSON.length
    
      }
    function formatDate(dateString,formatPattern){
        try {
          return format(parseISO(dateString), formatPattern)
        }catch(err){
          return ""
        }
      }
      
    function orderValue(unit) {
        return unit.order_quantity <= 0 ? '' : unit.order_quantity
    }

    function orderInput(product, unit) {
        return (
            <Box display="flex" justifyContent="flex-end" >
                <Box p={1} display="flex" justifyContent="center" flexDirection="column">
                    <Typography variant="h6" component="span" style={{ fontWeight: 600, fontSize: "16px" }}> <small>{unit.uom}</small></Typography>
                </Box>
                <Box p={1} style={{ maxWidth: "100px" }}>
                    <TextField
                        id="outlined-size-small"
                        variant="outlined"
                        size="small"
                        type="number"
                        value={orderValue(unit)}
                    />
                </Box>

            </Box>
        )
    }
    
    function renderInputedInventory(product){
 
        if(product.InputtedInventories){
          return (
            <List>
              {
                 product.InputtedInventories.map((inventory,index)=>{
                  return (
                    <ListItem divider key={index}>
                      <ListItemText
                          primary={
                            <div>
                              Quantity : {inventory.quantity} {inventory.uom}<br/>
                              Lot # : {inventory.lot_number}<br/>
                              Expiration : {formatDate(inventory.expiration_date,'MMM. dd, yyyy')}
                            </div>
                          }
                        />
                         <ListItemSecondaryAction>
                          <IconButton
                            edge="end"
                            aria-label="delete"
                            onClick={inventoryInputDeleteClick(product,inventory)}
                            size="large">
                            <DeleteIcon />
                          </IconButton>
                        </ListItemSecondaryAction>
                    </ListItem>
                  );
                  
                 })
              }
            </List>
          );
         
        }
        return ""
        
      }
      function deleteInputtedInventoryConfirmationDialog(){

        if(!inputtedInventoryToDelete){
          return("")
        }
        return(
          <Dialog
          open={showDeleteConfirmationDialog}
          onClose={()=>{setShowDeleteConfirmationDialog(false)}}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          >
          <DialogTitle id="alert-dialog-title">{"Are you sure to delete inventory data?"}</DialogTitle>
          <DialogContent>
           
              
              <div>
                {productToDeleteInventory.name}<br/>
                Quantity: {inputtedInventoryToDelete.quantity} {inputtedInventoryToDelete.uom}<br/>
                Lot #: {inputtedInventoryToDelete.lot_number}<br/>
                Expiration: {formatDate(inputtedInventoryToDelete.inputtedInventoryToDelete,'MMM. dd, yyyy')}
              </div>
              
            
          </DialogContent>
          <DialogActions>
            <Button onClick={()=>{setShowDeleteConfirmationDialog(false)}} color="primary">
              No
            </Button>
            <Button onClick={deleteInventoryBtnClick} color="primary" autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
        )
      } 
    function productElement(product) {
        return (
          <Card elevation={0} style={{ width: "100%" }}>
            <CardContent>
              <Grid container item>
                <Grid
                  container
                  direction="column"
                  justifyContent="space-between"
                  alignItems="stretch"
                >
                  <Grid
                    item
                    container
                  >
                    <Grid item xs={2} md={1} lg={1} >
                      <img
                        src={product.image}
                        alt={product.name}
                        style={{ width: "100%" }}
                      />
                    </Grid>
    
                    <Grid item xs container direction="column">
                      <Box style={{ fontWeight: 600, fontSize: "14px" }}>
                        {product.brand}
                      </Box>
                      <Box style={{ fontWeight: 600, fontSize: "14px" }}>
                        {product.name}
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid item>
                    {
                     renderInputedInventory(product)
                    }
                  </Grid>
                  <Grid item container justifyContent="flex-end"></Grid>
                </Grid>
              </Grid>
            </CardContent>
            <CardActions>
              <Button
                variant="contained"
                color="primary"
                size="small"
                className={classes.button}
                startIcon={<AddIcon />}
                onClick={()=>{
                  
                  setSelectedProduct(product);
                  setOpenInventoryAddLotNumberAndExpiration(true)
                
                }}
              >
                Input Inventory
              </Button>
            </CardActions>
          </Card>
        );
      }
    function productLists() {
        return (
            <List>
                {
                    products.map(product => (
                        <React.Fragment key={product.id}>
                            <ListItem >
                                {productElement(product)}
                            </ListItem>
                            <Divider light />
                        </React.Fragment>
                    )
                    )
                }
            </List>
        )
    }

  
    useEffect(()=>{
        const temporaryInventoryString = localStorage.getItem(companyId+"_temporary_inventory_count");
        // console.log(temporaryInventoryString)
         if (temporaryInventoryString == null) {
         
           
           return;
         }
 
         const temporaryInventoryJSON = JSON.parse(temporaryInventoryString);
         setProducts(temporaryInventoryJSON)
    },[])
  
    return (
      <React.Fragment>
              <Dialog fullScreen open={props.openInventoryProductsReview} onClose={() => { props.setOpenInventoryProductsReview(false) }} TransitionComponent={Transition}>
                  <AppBar className={classes.appBar}>
                      <Toolbar>
                          <IconButton
                            edge="start"
                            color="inherit"
                            onClick={() => { props.setOpenInventoryProductsReview(false) }}
                            aria-label="close"
                            size="large">
                              <CloseIcon />
                          </IconButton>
                          <Typography variant="subtitle1" className={classes.title}>
                              Inventory Products Review
                      </Typography>
                      </Toolbar>
                  </AppBar>
                  <div className={classes.appBarSpacer}></div>
                  <Paper square className={classes.productListPaper}>
                      {productLists()}
                  </Paper>
                  <AppBar position="fixed" color="primary" className={classes.appBarBottom}>
                      <Toolbar>
                      
                          <div className={classes.grow} />

                          <Button variant="contained" onClick={() => { 
                              if(totalProductCountWithInventoryInputted() <=0){
                                  alert("Please input inventory.")
                                  return
                              }
                              props.setOpenReturnInformationReview(true) 
                              
                              }} >
                              <Typography variant="caption">
                                  Finalize Inventory
                              </Typography>
                              <Badge badgeContent={totalProductCountWithInventoryInputted()} color="secondary" style={{ marginLeft: "1rem" }} />
                          </Button>

                      </Toolbar>
                  </AppBar>
                  {openInventoryAddLotNumberAndExpiration ? 
                      <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={materialTheme}>
                        <InputInventoryDialog 
                        onProductInputtedInventory={onProductInputtedInventory}
                        companyId={companyId}
                        selectedProduct={selectedProduct}
                        openInventoryAddLotNumberAndExpiration ={openInventoryAddLotNumberAndExpiration} 
                        setOpenInventoryAddLotNumberAndExpiration={setOpenInventoryAddLotNumberAndExpiration}/>
                    </ThemeProvider>
                      </StyledEngineProvider>
                      :""
                  }
                   <StyledEngineProvider injectFirst>
                     <ThemeProvider theme={materialTheme}>
                    {deleteInputtedInventoryConfirmationDialog()}
                    </ThemeProvider>
                   </StyledEngineProvider>
              </Dialog>
          
          </React.Fragment>
    );
}

export default InventoryReview